module.exports = __webpack_public_path__ + "img/logo.e4f03c8c.svg";